import 'css-chunksrc/client/common/filterMenu/section/styles.scss';export default {
  "header": "_header_u8ko4_1",
  "iconBox": "_iconBox_u8ko4_10",
  "icon": "_icon_u8ko4_10",
  "open": "_open_u8ko4_24"
};